import React from 'react';
import '../styles/globals.css';
import EnhancedAppRouter from './routers/EnhancedAppRouter.jsx';
import { StoreProvider } from './contexts/StoreContext.jsx';
import { ThemeProvider } from './contexts/ThemeContext.jsx';

function App() {
  return (
    <ThemeProvider>
      <StoreProvider>
        <EnhancedAppRouter />
      </StoreProvider>
    </ThemeProvider>
  );
}

export default App;
